<!--noteview request changes-->
<app-note-view *ngIf="!isLoading.value" [color]="'info'" [icon]="STRING_CONSTANTS.ICON.IC_INFORMATION" [text]="getNoteviewText()" />

<!-- plafon kredit section cards: -->
<!--<pre>creditGrantedControl.valid {{ creditGrantedControl.valid }}</pre>-->
<app-card-verification-form
  [bodyData]="creditCeilingSubject.value"
  [title]="'Plafon yang Diberikan'"
  [isLoading]="isLoading"
  [typeSection]="EnumCardVerificationSection.CREDIT_CEILING_GRANTED"
  [isNotHaveRevision]="checkNoRevision(responseSubject.value.credit_ceiling && responseSubject.value.credit_ceiling.credit_ceiling_granted)"
  [status]="getVerifiedStatus(responseSubject.value.credit_ceiling && responseSubject.value.credit_ceiling.credit_ceiling_granted)"
  [cardNoteValue]="noteValue(EnumCardVerificationSection.CREDIT_CEILING_GRANTED)"
  [customModalButton]="{ enable: true, text: 'Lihat Detail Piutang' }"
  [sessionKey]="REVISION_SESSION.EDIT_REQUEST_FINANCE"
  (customModalButtonTrigger)="onTriggerCustomModalButton($event)"
  (cardNoteChanged)="onNoteChanges($event)"
  (afterActionVerification)="afterActionVerification($event)"
>
  <app-modal #modalDetailPiutang [modalConfig]="modalDetailPiutangConfig" [modalOptions]="{ size: 'lg' }">
    <app-section-loader *ngIf="loadingBills | async; else billDetailTpl" />
    <ng-template #billDetailTpl>
      <ng-container *ngIf="billDetailSubject | async as billDetails">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="border border-gray-300 card-rounded p-4 h-100">
              <p class="fw-bolder mb-5">Tagihan Jatuh Tempo ({{ billDetails?.over_due_percent }}%)</p>
              <ng-container *ngFor="let item of billDetails?.over_due">
                <div class="d-flex align-items-center ms-n4 my-3">
                  <span class="text-gray-300 px-4 min-w-200px">{{ item.name }} hari</span>
                  <span class="px-4">: {{ utils.toRupiah(+item.value) }}</span>
                </div>
              </ng-container>

              <div class="d-flex align-items-center ms-n4 mt-6">
                <span class="text-gray-300 px-4 min-w-200px">Total</span>
                <span class="px-4 text-danger fw-bold">: {{ utils.toRupiah(billDetails?.over_due_total) }} </span>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="border border-gray-300 card-rounded p-4 h-100">
              <p class="fw-bolder mb-5">Tagihan Belum Jatuh Tempo ({{ billDetails?.not_due_percent }}%)</p>

              <ng-container *ngFor="let item of billDetails?.not_due">
                <div class="d-flex align-items-center ms-n4 my-3">
                  <span class="text-gray-300 px-4 min-w-200px">{{ item.name }} hari</span>
                  <span class="px-4">: {{ utils.toRupiah(+item.value) }}</span>
                </div>
              </ng-container>

              <div class="d-flex align-items-center ms-n4 mt-6">
                <span class="text-gray-300 px-4 min-w-200px">Total</span>
                <span class="px-4 fw-bold">: {{ utils.toRupiah(billDetails?.not_due_total) }} </span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-template>
  </app-modal>
</app-card-verification-form>

<!--<pre>saleTargetControl.valid: {{ saleTargetControl.valid }}</pre>-->
<app-card-verification-form
  [isLoading]="isLoading"
  [bodyData]="saleTargetSubject.value"
  [title]="'Target Penjualan'"
  [typeSection]="EnumCardVerificationSection.SALE_TARGET"
  [isNotHaveRevision]="checkNoRevision(responseSubject.value.credit_ceiling && responseSubject.value.credit_ceiling.sale_target)"
  [status]="getVerifiedStatus(responseSubject.value.credit_ceiling && responseSubject.value.credit_ceiling.sale_target)"
  [cardNoteValue]="noteValue(EnumCardVerificationSection.SALE_TARGET)"
  [sessionKey]="REVISION_SESSION.EDIT_REQUEST_FINANCE"
  (cardNoteChanged)="onNoteChanges($event)"
  (afterActionVerification)="afterActionVerification($event)"
/>

<!--<pre>creditBillingControl.valid: {{ creditBillingControl.valid }}</pre>-->
<app-card-verification-form
  [isLoading]="isLoading"
  [bodyData]="creditBillingSubject.value"
  [title]="'Penagihan Kredit'"
  [typeSection]="EnumCardVerificationSection.CREDIT_BILLING"
  [isNotHaveRevision]="checkNoRevision(responseSubject.value.credit_ceiling && responseSubject.value.credit_ceiling.credit_billing)"
  [status]="getVerifiedStatus(responseSubject.value.credit_ceiling && responseSubject.value.credit_ceiling.credit_billing)"
  [cardNoteValue]="noteValue(EnumCardVerificationSection.CREDIT_BILLING)"
  [sessionKey]="REVISION_SESSION.EDIT_REQUEST_FINANCE"
  (cardNoteChanged)="onNoteChanges($event)"
  (afterActionVerification)="afterActionVerification($event)"
/>

<!-- dokumen pembaruan card -->
<!--<pre>documentUpdateControl.valid: {{ documentUpdateControl.valid }}</pre>-->
<app-card-verification-form
  [isLoading]="isLoading"
  [title]="'Dokumen Pembaruan Data'"
  [bodyDataUpdateDocument]="documentUpdateSubject.value"
  [status]="documentUpdateSubject.value?.status_verified_enum"
  [typeSection]="EnumCardVerificationSection.DOCUMENT_UPDATE_DISTRIBUTOR"
  [type]="EnumCardVerificationForm.UPDATE_DOCUMENT"
  [cardNoteValue]="noteValue(EnumCardVerificationSection.DOCUMENT_UPDATE_DISTRIBUTOR)"
  [sessionKey]="REVISION_SESSION.EDIT_REQUEST_FINANCE"
  (cardNoteChanged)="onNoteChanges($event)"
  (afterActionVerification)="afterActionVerification($event)"
/>

<ng-container *ngIf="showButtonConfirm()">
  <div class="d-flex justify-content-end align-items-center mt-8 mb-20">
    <button mat-button color="primary" class="btn btn-primary btn-lg text-white"
            (click)="modalConfirmVerification.open()" [disabled]="!creditCeilingForm.valid">
      <span>Konfirmasi</span>
    </button>
  </div>
</ng-container>

<app-modal #modalConfirmVerification [modalConfig]="modalConfigConfirm" [modalOptions]="{size: 'md'}">
  <div class="mb-n6">
    <p>Apakah anda yakin mengonfirmasi Distributor:</p>

    <div class="my-4" *ngIf="detailHeader as detail">
      <div class="row mb-4">
        <div class="col-12 col-md-4"><span class="text-gray-700">Nama Distributor</span></div>
        <div class="col-12 col-md-8">
          <span class="text-gray-700 me-2">:</span> <span>{{ detail.business_name ?? '-' }}</span>
        </div>
      </div>
      <div class="row mb-4 text-capitalize">
        <div class="col-12 col-md-4"><span class="text-gray-700">Cakupan</span></div>
        <div class="col-12 col-md-8">
          <span class="text-gray-700 me-2">:</span> <span>{{ detail.sales_area ?? '-' }}, {{ detail.sales_sub_area ?? '-' }}</span>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-12 col-md-4"><span class="text-gray-700">Regional Head</span></div>
        <div class="col-12 col-md-8">
          <span class="text-gray-700 me-2">:</span> <span>{{ detail.regional_head_name ?? '-' }}</span>
        </div>
      </div>
    </div>

    <ng-container *ngIf="hasRevisionNote(); else defaultTextTpl">
      <p class="mt-8">
        <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_DANGER" class="svg-icon svg-icon-1 me-2"></span>
        <strong>Catatan Perbaikan</strong>
      </p>
      <div class="row mb-4" *ngFor="let rev of getRevisionDataBody()">
        <div class="col-12 col-md-4"><span class="text-gray-700">{{rev.label}}</span></div>
        <div class="col-12 col-md-8">
          <span class="text-gray-700 me-2">:</span>
          <span>{{rev.value}}</span>
        </div>
      </div>
    </ng-container>

    <ng-template #defaultTextTpl>
      <p class="mb-0">
        Setelah dikonfirmasi, Distributor akan <strong>diperbarui</strong>. Pastikan semua data telah lengkap dan benar.
      </p>
    </ng-template>
  </div>
</app-modal>

<app-modal #modalResponseVerification [modalConfig]="modalConfigResponse" [modalOptions]="{ size: 'md' }">
  <div class="d-flex flex-column justify-content-center align-items-center mb-n6">
    <ng-container *ngIf="loadingSubmit | async; else responseTpl">
      <div class="mt-8">
        <mat-spinner></mat-spinner>
      </div>
    </ng-container>
    <ng-template #responseTpl>
      <span [inlineSVG]="STRING_CONSTANTS.ICON.SUCCESS_ALERT"></span>

      <div class="d-flex flex-column w-100 text-center mt-4">
        <span>Permintaan pembaruan data distributor berhasil dikonfirmasi.</span>
        <span *ngIf="hasRevisionNote()">Catatan perbaikan & Data Distributor dikembalikan ke Regional Head.</span>
      </div>
    </ng-template>
  </div>
</app-modal>
